<div class="module_search">
  <input type="text"
         [placeholder]="placeHolder"
         #input
         [ngbTypeahead]="searchModuleBinding"
         [inputFormatter]="formatter"
         [resultTemplate]="rt"
         (selectItem)="onSelectItem($event)"
         [editable]="false"
         (typeahead-min-length)="3"
         [value]="moduleDisplayName"
         [disabled]="moduleDisplayName && disableAfterSelection">
</div>

<ng-template #rt
             let-r="result"
             let-t="term">
  <ngb-highlight [result]="formatModule(r)"
                 [term]="t"></ngb-highlight>
</ng-template>
